import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import VideoSkipBackwardFifteenIcon from '@atlaskit/icon/core/video-skip-backward-fifteen';

import { useAudioPlayerStreamingContext } from '../../../context/AudioPlayerStreamingProvider';

import { AudioControlIconButton } from './sub-components/AudioControlButton';

const SKIP_SECONDS = 15;
const START_SECONDS = 0;

const i18n = defineMessages({
	skipBackButtonLabel: {
		id: 'audio.miniplayer-controls.skip-back-label',
		defaultMessage: 'Skip 15 seconds backward',
		description:
			'The label is used for accessibility for the icon button which will skip the currently active audio back "x" seconds',
	},
	skipBackButtonTooltip: {
		id: 'audio.miniplayer-controls.skip-back-label',
		defaultMessage: 'Skip backward',
		description:
			'The label is used as a tooltip for the icon button which will skip the currently active audio back "x" seconds',
	},
});

export type SkipBackButtonProps = {
	isDisabled?: boolean;
	onClick?: () => void;
};

export const SkipBackButton = ({
	onClick = () => {},
	isDisabled = false,
}: SkipBackButtonProps): React.ReactNode => {
	const intl = useIntl();
	const { audioRef } = useAudioPlayerStreamingContext();

	const handleSkipBack = () => {
		const audio = audioRef.current;
		if (audio) {
			if (audio.currentTime <= SKIP_SECONDS) {
				audio.currentTime = START_SECONDS;
			} else {
				audio.currentTime -= SKIP_SECONDS;
			}
		}
	};

	const handleClick = () => {
		handleSkipBack();
		onClick?.();
	};

	return (
		<AudioControlIconButton
			Icon={VideoSkipBackwardFifteenIcon}
			label={intl.formatMessage(i18n.skipBackButtonLabel)}
			tooltip={intl.formatMessage(i18n.skipBackButtonTooltip)}
			onClick={handleClick}
			isDisabled={isDisabled}
			testId="miniplayer-skip-back"
		/>
	);
};
